import { useState } from "react";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const initialAddresses = [
  {
    address_name: "Home",
    address_details: "5033 N Phoenix Ave, Fresno, CA 93723",
  },
  {
    address_name: "Work",
    address_details: "Sandhill Rd, Menlo Park, CA",
  },
];
function useAddressesLogic() {
  const [addresses, setAddresses] = useState(initialAddresses);
  const history = useHistory();
  const addNewAddress = (newAddress) => {
    console.log({ newAddress });
    setAddresses([...addresses, newAddress]);
    history.push(`${ROUTES.PROFILE}${ROUTES.MY_ADDRESSES}`);
  };
  return { addresses, addNewAddress };
}

export default useAddressesLogic;
